export const fr = {
  translation: {

    'corpusSelection':'Sélection du corpus',
    'queryDefinition':'Définition de la requête',
    'signIn': 'Connexion',
    'signUp': 'Créer un compte',
    'logOut': 'Déconnexion',
    'pleaseLogIn': "Veuillez vous connecter pour accéder à toutes les fonctionnalités",

    'logIn': 'Identifiant',
    'password': 'Mot de passe',
    'credentialsErrorsMsg': "Identifiants incorrects. Veuillez réessayer ou créer un compte si vous n'en n'avez pas encore un.",
    'successfulSignUpMsg': "Votre compte a été créé avec succès ! Veuillez maintenant vous connecter.",

    'name': "Nom",
    'firstName': "Prénom",
    'affiliation': "Affiliation",
    'country': "Pays",
    'status': "Statut",
    'email': "Email",
    'passwordConfirmation': "Confirmation du mot de passe",
    'terms': "Conditions d'utilisation",
    'IAgreeToTerms': "Je certifie avoir pris connaissance des modalités d'accès à l'application PhraseoBase. Je m'engage à les respecter strictement et certifie l'exactitude des renseignements portés dans le présent formulaire.",
    'detailedDataPolicy': "Les informations recueillies font l’objet d’un traitement informatique destiné à l'équipe de chercheurs du Lidilem. Ces informations n'ont pas d'autres objet que de mieux connaître les utilisateurs du Lexicoscope. Les destinataires des données sont des membres du Laboratoire Lidilem, Université Grenoble Alpes. Conformément à la loi « informatique et libertés » du 6 janvier 1978 modifiée en 2004, vous bénéficiez d’un droit d’accès et de rectification aux informations qui vous concernent, que vous pouvez exercer en vous adressant à olivier.kraif@univ-grenoble-alpes.fr, Lidilem (ou en modifiant ces informations directement via l'interface du site). Vous pouvez également, pour des motifs légitimes, vous opposer au traitement des données vous concernant.",
    'scholar': "Chercheur",
    'teachingScholar': "Enseignant-chercheur",
    'FFLTeacher': "Enseignant FLE",
    'phdStudent': "Doctorant ou post-doctorant",
    'student': "Etudiant",
    'other': "Autre",

    'addMissingFieldsMsg': "Veuillez remplir les champs manquants puis soumettre le formulaire à nouveau",
    'addLoginTakenMsg': "Cet identifiant est déjà pris, veuillez en choisir un autre et soumettre le formulaire à nouveau",
    'addErrorMsg': "Une erreur est survenue, merci de réessayer plus tard",
    'addEmailSentMsg': "Succès ! Bienvenue sur le Lexicoscope !",

    'usePredefinedCorpus': "Utiliser une collection prédéfinie",
    'useCustomCorpus': "Construire un corpus personnalisé",
    'useSavedCorpus': "Réutiliser un corpus personnalisé précédemment sauvegardé",

    'goToQuery': "Passer à la définition de la requête !",

    'predefinedCorpus': "Collections publiques",
    'language': "Langue",
    'collectionChoice': "Choix de la collection",
    'keyCaracteristics': "Caractéristiques clés",
    // note: the colon are included on purpose to reflec the different syntax rule
    // between French (one space before) and English (no space)
    'periodColon': "Période :",
    'categoryColon': "Catégorie :",
    'tokenNumberColon': "Nombre de tokens :",
    'formNumberColon': "Nombre de formes (hors symboles et ponctuations) :",
    'docNumberColon': "Nombre de documents :",
    'paraNumberColon': "Nombre de paragraphes :",
    'clsNumberColon': "Nombre de clauses :",
    'sentNumberColon': "Nombre de phrases :",
    'tokenNumber': "Nombre de tokens",
    'formNumber': "Nombre de formes",
    'docNumber': "Nombre de documents",
    'paraNumber': "Nombre de paragraphes",
    'clsNumber': "Nombre de clauses",
    'sentNumber': "Nombre de phrases",

    'estimatedFrequencyColon': "Fréquence estimée :",
    'frequencyColon': "Fréquence :",
    'description': "Description",

    'savedCorpusHeader': "Corpus précédemment sauvegardés",
    'recapInfo': "Informations récapitulatives",
    'creationDate': "Date de création",

    'selectExistingTexts': "Sélectionner des textes de collections existantes",
    'importYourOwnTexts' : "Importer vos propres textes",
    'reset': "Réinitialiser",
    'customCorpusTitle': "Créez votre propre corpus",
    'customCorpusDesc': "Définissez un ou plusieurs sous-corpus ou partitionnez-en un grâce à des clés de partition",
    'globalParams': "Paramètres globaux",
    'corpusName': "Nom du corpus",
    'corpusLang': "Langue du corpus",
    'advancedParams': "Paramètres avancés (optionnels)",
    'alignedLang': "Langue alignée (langue dans laquelle le texte est traduit)",
    'partSubCorpus': "Partition du sous-corpus",
    'addSubCorpus': "Ajouter un sous-corpus",
    'searchRecapColon': "Récapitulatif du corpus :",
    'saveCustomCorpus': "Enregistrer le corpus",
    'confirmSaving': "Confirmer la sauvegarde",
    'currentCorpusCanBeSavedInYourPersonalDirectoriesOnTheServer': "Le corpus actuel peut être enregistré sur le serveur dans votre répertoire personnel.",
    'close': "Fermer",
    'corpusNameIsNotDefined': "Le nom du corpus n'a pas été défini",
    'LanguageIsNotDefined': "La langue du corpus n'a pas été définie",
    'corpusHasBeenSaved': "Le corpus a été sauvegardé",
    'pleaseAddAtLeastOneSubcorpus': "Il faut définir au moins un sous-corpus",

    'subCorpusParams': "Paramètres du sous-corpus",
    'subCorpusName': "Nom du sous-corpus",
    'collection': "Collection",
    'filters': "Filtres",
    'categories': "Categories",
    'noResult': "Aucun résultat",
    'filterByCategories': "Filtrer par catégories...",
    'authors': "Auteurs",
    'filterByAuthors': "Filtrer par auteurs...",
    'titles': "Titres",
    'filterByTitles': "Filtrer par titres...",
    'sourceLangs': "Langues sources (langues originales des textes)",
    'filterBySourceLangs': "Filtrer par langues sources...",
    'docsNumColon': "Nombre de documents :",
    'authorsNumColon': "Nombre d'auteurs :",

    'partKeys': "Clés de partition",
    'validate': "Valider",

    'advancedParamsBtn': "Paramètres avancés",
    'concordancesAndOccurrences':"Concordances et occurrences",
    'lexicalClasses':"Classes lexicales",
    'lexicalClassDefinition':"Définition des classes lexicales à partir d'expressions régulières",
    'oneClassPerLine':"Une classe par ligne, selon la syntaxe suivante : $CLASSNAME=FORM1|FORM2|...|FORMn",
    'realizationDefinition':"Définition des réalisations du pivot et des collocatifs",
    'realizationType':"Type de réalisation",
    'asSurfaceOrQueryInstanciationOrIncludingSubTree':"comme réalisation de surface, comme instanciation de la requête, comme sous-arbre contenant les éléments de la requête",
    'relevantNodeFeatures':"Traits pertinents dans le pivot",
    'formLemmaCatOthers':'("w"=>forme, "l"=>lemme, "c"=>catégorie, "f"=> autres traits)',
    'relevantCollocFeatures':"Traits pertinents dans les collocatifs",
    'formLemmaCatOthersRelsPos':'"w"=>forme, "l"=>lemme, "c"=>catégorie, "f"=> autres traits, "r"=> relation de dépendances, "textP"=> position dans le texte, "divP"=> position dans la division, "paraP"=>position dans le paragraphe, "sentP"=>position dans la phrase )',
    'kwicDisplay':"Affichage Kwic",
    'kwicCentralFormat':"Format de la colonne centrale des sorties Kwic",
    'tok1OrFull':"(token #1 ou expression complète)",
    'coocWithNodeOnly':"Ne tenir compte que des cooccurrents en relation avec #1",
    'calcEstimatedValues':"Dans le cas d'une analyse incomplète (échantillonnage du corpus), calculer une valeur estimée des occurrences en se basant sur la taille de l'échantillon",
    'dispCriterion':"Critère de calcul de la dispersion",
    'assocMeasure' : "Mesure d'association entre cooccurrents",
    'innerCollocs':"Calcul de la mesure d'association interne (peut prendre du temps)",
    'searchSpaceDefinition': "Définition du périmètre des phrases à analyser",
    'zeroIfNoLimit':"0 si pas de limite.",
    'queryTimeLimit':"Durée maximale pour une requête",
    'inSec':"(en secondes)",
    'nbMax2Parse':"Nombre maximal de phrases à parser",
    'between0_100':"entre 0 et 100",
    'percent2Parse':"Pourcentage de phrases à parser",
    'overall':"(sur l'ensemble de recherche)",
    'nbMaxFound':"Nombre maximal d'occurrences dans les résultats",

    'typeAQuery': "Entrer une requête",
    'go': "Lancer",
    'queryColon': "Requête :",
    'exampleColon': "Exemple :",
    'tql': "TQL (requête avancée)",
    'exemplesOfAdvancedQueriesColon': "Exemples de requêtes avancées :",
    'suggestionOfAdvancedQueries': "Suggestion de requêtes avancées",
    'suggestedQueriesExplanation': "Cliquez sur une des suggestions ci-dessous pour générer automatiquement une requête avancée",
    'backToCorpusSelection': "Retour vers le choix du corpus",

    'query': "Requête",
    'stats': "Statistiques",
    'conc': "Concordances",
    'cooc': "Cooccurrences",
    'ws': "Wordsketch",
    'recap': "Récap",
    'elapsedTime': "Temps de calcul :",

    'global': "Global",
    'searchSpace': "Espace de recherche",
    'sentencesToParseColon': "Phrases à parser :",
    'sentencesParsedColon': "Phrases parsées :",
    'searchResults': "Résultats de recherche",
    'syntheticStats': "Statistiques synthétiques",
    'dispColon': "Dispersion :",
    'instancesNumColon': "Nombre d'instances :",
    'onlyASampleOfTheCorpusHasBeenSearched':"Seulement un échantillon du corpus a été exploré. Clickez ici pour relancez l'extraction sur la totalité du corpus (cette opération peut être longue, en fonction du nombre de phrases à parser).",
    'detailedStats': "Statistiques détaillées",
    'type': 'Type',
    'freqByCorpus': "Fréquence par corpus",
    'dispByCorpus': "Dispersion par corpus",
    'specByCorpus': "Spécificité par corpus",
    'dispByReal': "Dispersion par réalisation",
    'freqByReal': "Fréquence par réalisation",
    'freqByDoc': "Fréquence par document",
    'specByDoc': "Spécificité par document",

    'dispersion': "Dispersion",
    'frequency': "Fréquence",
    'specificity': "Spécificité",
    'realization': "Réalisation",
    'title': "Titre",
    'byReal': "par réalisation",
    'byCorpus': "par corpus",
    'byDoc': "par document",
    'graphicalRepr': "Représentation graphique",
    'completeResList': "Liste complète des résultats",

    'KWIC/Unfolded': "KWIC/Déplié",
    'ShowMetadata':"Données phrase courante",
    'leftContext': "Contexte gauche",
    'node': "Pivot",
    'rightContext': "Contexte droit",
    'largeContext' : "Contexte élargi",

    'docMeta': "Meta-données du document",
    'tokens': "Tokens",
    'id': "Identifiant",
    'category': "Catégorie",
    'features': "Traits",
    'lemma': "Lemme",
    'form': "Forme",
    'syntaxicTree': "Arbre syntaxique",

    'corpus': "Corpus",
    'expression': "Expression",
    'collocate': "Collocatif",
    'coocNum': "Cooccurrences (via une relation)",
    'pivotOccNum': "Nombre de relations avec le pivot",
    'collOccNum': "Nombre de relations avec le collocatif",
    'relOccNum': "Nombre total de relations",
    'relation': "Relation",
    'relations': "Relations",
    'logLike': "Log-like",

    'recapSearchAndResults': "Récapitulatif de la requête et des résultats",
    'querySentColon': "Requête envoyée (TQL) :",
    'searchArea': "Ensemble de recherche",
    'collectionColon': "Collection :",
    'categoriesColon': "Catégories : ",
    'sourceLangsColon': "Langues sources :",
    'tokenNumColon': "Nombre de tokens :",
    'caracteristics': "Caractéristiques",
    'langColon': "Langue :",
    'alignedLangColon': "Langue alignée :",
    'nbSentsToParseColon': "Nombre de phrases à parser :",
    'nbParsedSentsColon': "Nombre de phrases parsées :",

    'compare':'Comparer',
    'coocSpecComparisonBtn':'Comparaison des spécificités des cooccurrents',
    'coocComparisonBtn':'Comparaison des cooccurrents',

    'whatIsLexicoscope':"Qu'est-ce que le Lexicoscope 2.0 ?",
    'intro':"Le Lexicoscope, initialement baptisé EmoConc, a été développé à partir de 2011 pour explorer les corpus du projet ANR-DFG Emolex. C'est un outil d'exploration de corpus tout spécialement dédié à l'exploration de profils combinatoires de mots ou d'expressions, en se basant sur les dépendances syntaxiques (par exemple, les relations sujet-verbe, ou verbe-objet). La version 2.0 du Lexicoscope a été intégralement redéveloppée afin d'optimiser les recherches sur de vastes ensemble textuels et pour comparer les spécificités entre différents sous-corpus.",
    'strength':"Ce que le Lexicoscope 2.0 apporte de nouveau",
    'strength1':"Un accès à de vastes corpus originaux, en plusieurs langues, tels que PhraseoRom, EmoBase, Scientext...",
    'strength2':"La recherche sur des expressions complexes à partir d'exemples.",
    'strength3':"La possibilité de comparer de vastes corpus de genres textuels différents.",
    'strength4':"La possiblité de sauvegarder votre propre définition des sous-corpus et des requêtes, et d'importer de nouveaux corpus.",
    'comingSoon':"Prochains développements",
    'todo1':"Des fonctionnalités avancées telles que la clusterisation automatique de contexte, la clusterisation temporelle, l'indexation des passages textuels, l'AFC à partir du vocabulaire, etc.",
    'todo2':"Une interface graphique d'élaboration des requêtes",
    'todo3':"La possibilité d'effectuer des équations syntaxiques",
    'notaBene':"Pour accéder à certaines fonctionnalités avancées couteuses en calculs (ALR, MLM, etc.), vous devez demander à l'administrateur (Olivier.Kraif@univ-grenoble-alpes.fr) un statut de user+",
    'testTheTool':"Tester la plate-forme",
    'alignedSentence':"Phrase(s) alignée(s)",
    'multivarStats':"Statistiques multivariées",
    'specOccStats':"Occurrences en fonction des sous-corpus",
    'specCoocStats':"Cooccurrences en fonction des sous-corpus",
    'assocCoocStats':"Cooccurrences en fonction des réalisations",
    'hclust':"Clustering hiérarchique ascendant ",
    'xtab':"Tableau croisé",
    'mds':"Echelonnement multidimensionnel",
    'pca':"Analyse en composantes principales",
    'ca':"Analyse des correspondances",
    'distMat':"Matrice des distances - Heatmap",
    'dendrogram':"Dendrogramme",
    'chart':'Représentation graphique',
    'widget1':'Variable 1',
    'widget2':'Variable 2',
    'noTitleIfNotLogged':'Pour voir les titres des documents, prière de vous connecter.',
    'mainTable':'Table principale',
    'vocSize' : "Taille du vocabulaire (types)",
    'TTR' : "Rapport types / tokens (TTR)",
    'vocSizeColon' : "Taille du vocabulaire (types) :",
    'TTRColon' : "Rapport types / tokens (TTR) :",
    'vocabulary' : "Vocabulaire du corpus",
    'collocCollig' : "Collocations et colligations",
    'associationMeasure' : "mesure d'association",
    'specificVocabulary' : "Vocabulaire spécifique",
    'globalStats' : "Statistiques globales",
    'vocSpecComparison' : "Comparaison des spécificités",
    'globalLemmata' : "Vocabulaire - Lemmes",
    'globalPos' : "Vocabulaire - Parties du discours",
    'specificLemmata' : "Lemmes spécifiques",
    'specificPos': "Catégories spécifiques",
    'totFreq' : "Fréquence totale",
    'globalCollocCollig':"Collocations et colligations globales",
    'specificCollocCollig':"Collocations et colligations spécifiques",
    'globalColloc':"Collocations globales",
    'specificColloc':"Collocations spécifiques",
    'globalRel':"Relations globales",
    'specificRel':"Relations spécifiques",
    'meanAssocSpec' : "Moyenne(Assoc,Spec)",
    'rank' : "Rang",
    'clickedCollocIsTheHead' : "En cliquant sur un des deux cooccurrents, celui-ci sera pris comme tête dans la cooccurrence syntaxique. Les résultats sont donc différents si vous cliquez sur l'un ou l'autre des cooccurrents.", 
    'help' : "Aide",
    'videoTutorial' : "Tutoriels vidéos",
    'presentation' : "Présentation générale",
    'simpleQuery' : "Rechercher des mots simples",
    'advancedQuery' : "Rechercher des expressions complexes",
    'searchSpecificVocabulary' : "Etudier le vocabulaire et les étiquettes spécifiques",
    'customCorpus' : "Elaborer un corpus personnalisé",
    'devTeam' : "Equipe de développement :",
    'interface' : "Interface (PHP/JS/REACT) :",
    'searchEngine' : "Moteur de requêtes lexico-syntaxiques (Perl) :",
    'multivariateAnalysis' : "Analyses multivariées (Perl, R) :",
    'funding' : "Financement :",
    'termDefinition' : "Définition des termes",
    'specHelp' : "La spécificité indique si la fréquence d'une observation dans un sous-corpus s'écarte de sa fréquence moyenne dans l'ensemble du corpus. Si la fréquence relative observée est très supérieure à la fréquence relative moyenne, la spécificité sera élevée et positive. Si elle est très inférieure elle sera élevée et négative. Si elle est voisine, elle sera proche de 0. C'est la mesure du Loglike qui permet ici de la calculer.",
    'freqHelp' : "La fréquence est le nombre de fois qu'une observation apparait dans le corpus (ou sous-corpus), en valeur absolue. C'est le nombre d'occurrences.",
    'realHelp' : "Une réalisation est la manière dont un pattern abstrait se réalise en surface. Par exemple, le pattern <c=ADJ> <l=admiration> peut se réaliser en <l=grand,c=ADJ> <l=admiration,c=NOUN> ou <l=immense,c=ADJ> <l=admiration,c=NOUN>.",
    'dispHelp' : "La dispersion indique par défaut le nombre de documents où l'expression apparait (fréquence de document). La dispersion peut se calculer suivant différents critères, modifiables dans les paramètres avancés : année de publication, auteur, sous-corpus, etc.",
    'runMultivar' : "Lancer les calculs multivariés sur les résultats",
    'assocHelp' : "Une mesure d'association permet d'évaluer la force du lien statistique entre deux cooccurrents (on compare la fréquence de cooccurrence observée avec celle qu'on pourrait espérer par le simple jeu du hasard). Ici la mesure d'association utilisée est l'information mutuelle spécifique. Elle a la propriété de mettre en avant les cooccurrences d'éléments peu fréquents. Elle est complémentaire de la fréquence de cooccurrence, qui favorisera plutôt, comme le loglike, les associations entre unités très fréquentes.",
    'aboutCooccurrenceAndWordsketchesTitle' : "A propos des cooccurrents et des wordsketches",
    'aboutCooccurrenceAndWordsketches' : "Le tableau des cooccurrents affiche tous les cooccurrents syntaxiques dont la cofréquence est supérieure ou égal à 3. Les statistiques (fréquences marginales, cofréquence, loglike, etc.) sont calculées toutes relations confondues. Les wordsketches synthétisent ces données en séparant les cooccurrents en fonction du type de relation, et en ne retenant que les cooccurrents pour lesquels le loglike dépasse un certain seuil (>=5). En outre, pour ne pas surcharger l'affichage, les wordsketches n'enregistrent que les 15 meilleurs cooccurrents (au plan du loglike).",
    'udTagSetLink' : "Liens vers la documentation du tagset UD",
    'deprel':"Relations (DEPREL)",
    'upos':"Parties du discours (UPOS)",
    'alr' : "ALR",
    'runAlr' : "Lancer le calcul des ALR (Arbres lexicosyntaxiques récurrents)",
    'firstLevelColloc' : "1er Collocatif",
    'size' : "Taille", 
    'example' : "Exemple\u00a0d'occurrence\u00a0en\u00a0contexte",
    'alrOccNum' : "Occurrences de l'ALR",
    'alrSpecComparisonBtn' : "Comparaison des spécificités des ALR",
    'permalink' : "Permalien",
    'suggest' : "Suggérer",
    'suggestExplanation':"Pour construire une requête complexe, vous pouvez taper une expression puis cliquer sur le bouton [Suggérer]",

    'alrDefinition' : "Définition des ALRs",
    'minSizeMaxSize' : "Taille des ALRs [min,max]",
    'sizeHelp' : "Deux entiers supérieurs à 2",
    'freqMinAlr' : "Fréquences minimales à chaque itération",
    'freqMinAlrHelp' : "Liste d'entiers séparés par des virgules",
    'dispMinAlr' : "Dispersion minimum",
    'dispMinAlrHelp' : "Valeur conseillée sup. ou égale à 2",
    'alrInitialization' : "Première itération",
    'collocCatFilter' : "Filtre des catégories pour l'expansion initiale (A la première itération, il est plus efficace de chercher des mots pleins)",
    'collocCatFilterHelp' : "Expression régulière",
    'amThreshold' : "Seuil minimal de la mesure d'association à la première itération",
    'alrIterations' : "Paramètres des itérations",
    'maxNbCollocs' : "Nombre max de collocatifs retenus à chaque itération",
    'useCollig' : "Si pas de collocatifs, chercher des colligations",
    'alrResult' : "Présentation des résultats",
    'minFreqChildrenRatio4Deduplicating' : "Ratio de fréquence minimal pour dédoublonner un ALR et ses sous-ALR inclus",
    'minFreqChildrenRatio4DeduplicatingHelp' : "Intervalle [0,1]. 1= pas de dédoublonnage.",
    'mergeAlr' : "Regroupement des lemmes pour les ALRs similaires",
    
    'generalize' : "Généralisation",

    'computationParam' : "Paramètres de calcul",
    'embeddingClassDefinition' : "Définition des classes lexicales à partir des embeddings",
    'cosSimilarityThreshold' : "Seuil minimal du cosinus pour similarité",

    'alrVersion' : `<h4>01/02/2021 : La nouvelle version des ALRs comprend les fonctionnalités suivantes : </h4>
      1/ dédoublonnage des sous-ALRs inclus dans un ALR plus long <br/>
      2/ recherche de colligations en l'absence de collocatifs <br/>
      3/ regroupement des ALRs similaires dans les résultats.<br/>
      Tous les paramètres sont accessibles dans les paramètres avancés.<br/><br/>`,
    'noAlr' : "Pas d'ALR trouvés. Diminuer les seuils de fréquence et de dispersion au niveau des paramètres pour avoir un résultat.",

    'update' : "Mettre à jour",

    'ref2cite': "Références",
    'reference1' : "Kraif Olivier &  Diwersy Sascha (2012). Le Lexicoscope : un outil pour l'étude de profils combinatoires et l'extraction de constructions lexico-syntaxiques. In Actes de la conférence TALN 2012, Grenoble, pp. 399-406.",
    'reference2' : "Kraif Olivier (2019). Explorer la combinatoire lexico-syntaxique des mots et expressions avec le Lexicoscope. In Max Silberstein (dir.), Langue française, N° 203, 67-82.",
    'reference3' : "Sascha Diwersy, Laetitia Gonon, Vannina Goossens, Olivier Kraif, Iva Novakova, Julie Sorba & Ilaria Vidotto (2021). La phraséologie du roman contemporain dans les corpus et les applications de la PhraseoBase, Corpus [En ligne], 22 | 2021, URL : http://journals.openedition.org/corpus/6101 ; DOI : https://doi.org/10.4000/corpus.6101",
    'reference4' : "Kraif Olivier, Novakova Iva & Siepmann Dirk (2019). Multi-Word Expressions and the Construction of Meaning in French and English Crime Fiction. In Flore Coulouma et Cécile Viollain (eds.), Paramétrer le sens en anglais et en français, Marqueurs et structures : articulations et constructions, Paris : Lambert Lucas, 23–38.",

    'realSpecComparisonBtn':'Comparaison des spécificités des réalisations',
    'enlarge':'Agrandir',
    'noWorsketchBeyondTheLoglikeThreshold':'Aucun cooccurrent n\'a franchi le seuil de loglike requis.',
    'minWordSketchLLR' : 'Seuil minimum de loklike pour les wordsketches',
    'maxWordSketchLength' : 'Taille max. de liste de collocatifs dans les wordsketches',
    'wordsketches' : 'Wordsketches',

    'importZipFile' : 'Téléverser un fichier (txt,zip)',
    'selectYourFile' : 'Sélection du fichier',
    'formatExplanation1' : 'Format zip : contient des fichiers XML-TEI, XML-CONLL, TSV ou TXT. Pour chaque fichier XXX.txt, adjoindre un fichier XXX.meta, contenant les métadonnées en TSV, avec des lignes de la forme : clé tab valeur. Taille maximale du corpus : 500 Ko.',
    'formatExamplesCanBeFindHereColon': 'Des exemples de format peuvent être téléchargés ici : ',
    'formatExplanation2' : 'Format zip : contient des fichiers TMX, TSV, XML-TEI, XML-CONLL, ou TXT. Les noms de fichiers doivent suivre le format NAME.L1.EXT, NAME.L2.EXT, NAME.L1-L2.TSV ou NAME.L1-L2.TMX ou NAME.L1-L2.TSV. Pour chaque fichier NAME.L1.TXT, adjoindre un fichier NAME.L1.meta, contenant les métadonnées en TSV, avec des lignes de la forme : clé tab valeur. Taille maximale du corpus : 500 Ko.',
    'contentExplanation' : 'Copier/coller votre texte directement dans ce champ (pas de métadonnées). Taille maximale du corpus : 500 Ko.',
    'importUsingUpload' : 'Importer par téléversement',
    'uploadFile' : 'Envoyer',

    'lemmatizeExample' : 'Lemmatiser la suggestion',
    'thanksToHumanum' : ' - Cette instance du Lexicoscope est gracieusement hébergée par la TGIR HumaNum.',
    'tokenCreditExhausted': 'La limite du nombre de tokens est atteinte. Supprimez d\'anciens corpus pour faire de la place.',
    'corpusAlreadyExists': 'Un corpus existe déjà avec ce nom. Utilisez un autre nom.',
    'importProcessTakesSomeTime':'Le traitement des textes téléversés est en cours... Cela peut prendre quelques minutes (compter environ 30 000 mots par minute pour le parsing avec Stanza).',
    'tokenCreditColon':'Nombre de tokens que vous pouvez importer :',
    'suppress': 'Supprimer',
    'confirmSuppressing': 'Confirmer la suppression',
    'suppressCorpusExplanation': 'Ce corpus va être supprimé ainsi que tous les fichiers d\'index associés. Attention cette opération ne peut être annulée par la suite.',
    'link2xmlFile': 'Lien vers le fichier XML contenant le corpus analysé.',
    'choseConstrastCorpusColon': 'Optionnellement, choisissez un corpus de contraste : ',
    'otherAttr': 'Attribut additionnel',
    'selectAValueForOtherAttr': 'Valeurs pour l\'attribut additionnel',
    'metadata': "Métadonnées",
    'metadataPerDocument': "Métadonnées par documents",
    'thisValuesAreEstimated' : "Ces valeurs (couleur orange) sont estimées (seul un échantillon du corpus a été parcouru).",
    'runAgain' : "Relancer sur l'intégralité du corpus",
    'credits' : "Crédits",
    'stanza' : "Les corpus importés sont parsés avec Stanza. Cf. Qi Peng, Zhang Yuhao, Zhang Yuhui, Bolton Jason & Manning Christopher D. (2020) Stanza: A Python Natural Language Processing Toolkit for Many Human Languages. arXiv:2003.07082 (https://nlp.stanford.edu/pubs/qi2020stanza.pdf)",
    'termostat' : "La mesure de poids terminologique nous a été donnée par Patrick Drouin, concepteur de TermostatWeb. Cf. Drouin P. & Doll F. (2008) Quantifying Termhood Through Corpus Comparison. Proc. of Terminology and Knowledge Engineering (TKE-2008)), Copenhagen, 191-206.",
    'source' : "Langue 1",
    'target' : "Langue 2",
    'unfolded' : "Vue dépliée",
    'vocStats' : "Vocabulaire",
    'readability' : "Lisibilité",
    'averageSentLengthToksColon' : "Nombre de tokens par phrase :",
    'averageClauseLengthToksColon' : "Nombre de tokens par clause :",
    'averageSentLengthFormsColon' : "Nombre de formes par phrase :",
    'averageWordLengthColon' : "Nombre de caractères par formes :",
    'chartComparison' : "Synthèse graphique",
    'subCorpusComparison' : "Comparaison des sous-corpus",
    'lexicalDensityColon' : "Densité lexicale (proportion de mots pleins / toutes les formes) :",
    'featureStats' : "Statistiques morphosyntaxiques",
    'repet4cat' : "Taux de répétition local, par catégorie",
    'averageLength' : "Longueur des formes",
    'averageSentLength' : "Longueur des phrases",
    'averageSentLengthToks' : "Nombre de tokens par phrase",
    'averageClauseLengthToks' : "Nombre de tokens par clause",
    'lexicalDensity' : "Densité lexicale",
    'repet4catExplanation' : "Taux de répétition : cette statistique indique le nombre moyen de répétitions d'un lemme ou d'une forme à l'interieur d'une fenêtre de largeur constante. Ce taux moyen est calculé en fonction de chaque partie du discours, pour les mots pleins seulement.",
    'maxSpanSizeColon' : "Taille de la fenêtre (en tokens) :",
    'useLemma4RepetColon' : "Mode de calcul (lemme ou forme) :",
    'filterByCat' : "Filtrer en fonction des parties du discours",
    'clust' : "Partionnement des contextes",
    'clustExplanation' : "On applique un algorithme de regroupement hiérarchique ascendant (complete-linkage clustering) en s'appuyant sur une mesure de similarité des contextes du pivot. Pour calculer cette similarité, on compare les mots issus des relations syntaxiques communes, en utilisant une similarité de plongements lexicaux (FastText). On calcule ensuite un Dice (somme des similarités divisée par le nombre moyen de relations impliquées).",
    'sampleSize' : "Taille de l'échantillon",
    'sampleSizeHelp' : "Pour des raisons de temps de calcul, on limite le partitionnement à un échantillon des contextes.",
    'cutThreshold' : "Seuil de distance",
    'cutThresholdHelp' : "Les classes en-deça de ce seuil sont fusionnées. La distance (égale à 1 - Dice) est comprise entre 0 et 1.",
    'runContextClustering' : "Lancer",
    'clickThreeTimesToOpenPopup' : "Cliquez trois fois sur une ligne pour avoir les informations détaillées sur le contexte.",
    'onlySyntax' : "Cocher pour que seule la syntaxe intervienne dans le calcul de distance (pas de recours à la similarité lexicale). Abaisser le seuil dans ce cas.",
    'context':"Contexte",
    'corpusReady':"Valider",
    'extractVocCollig':"Extraire les index (vocabulaire et collocations)",
    'specByReal':"Spécificité par réalisation",
    'analogCooc' : "Cooccurrents analogues à ",
    'analogCoocExplanation': "Même catégorie + similarité sémantique avec cosinus > 0.55 (vecteurs de Fasttext).",
    'differentPasswordMsg': "Les mots de passe ne se correspondent pas. Retapez le mot de passe.",
    'personalData' : "Données personnelles",
    'corpusProcessingIsLong' : "Le traitement prend plus de temps que prévu... Quand le corpus sera prêt il apparaitra dans la liste des corpus personnels.",
    'otherVersion' : "Autre version",
    'diffStats' : "Comparaison de versions (diff)",
    'statisticsForDiffComparisonBetweenVersions' : "Statistiques des formes différentes entre les versions",
    'formsThatAppearOnlyIn':"Formes qui apparaissent seulement dans",
    'ngrams':"N-grammes",
    'alignedPairs':"Paires alignées",
    'posTags':"Catégories",
    'posTagsNgrams':"N-grammes de catégories",
    'posTagsAlignedPairs':"Catégories alignées",  
    'addedOrModifiedToken':"Token ajouté ou modifié",
    'addedOrModifiedNgram':"N-gramme ajouté ou modifié",
    'dataUpdated' : "Mise à jour effectuée",
    'youMustLogInToAccessThisPage' : "Vous devez vous connecter pour accéder à cette page.",
    'concordSpan': "Taille du contexte (en car.)",
    'fullConcordSpan': "Intégrer les phrases voisines dans l'empan de concordance",
    'chronogram' :"Chronogramme",
    'timeStatsExtract': "Extraction du chronogramme (N.B.: l'espace de recherche doit être suffisamment complet pour avoir des statistiques fiables).",
    'timeStatsSpanType' : "Choisissez une unité de temps pour chaque empan du chronogramme",
    'timeStatsSpanLen' : "Choisissez une longueur pour chaque empan du chronogramme",
    'timeStatsSpanTypeHelp' : "Y=années, M=mois, D=jours",
    'timeStatsSpanLenHelp' : "p.ex. '3' avec 'M' donne un empan 3 mois",
    'nbTimeSpan' : "Nombre d'empans temporels",
    'beginningColon' : "Début :",
    'endingColon' : "Fin :",
    'beginning' : "Début",
    'ending' : "Fin",
    'freqByTimeId' : "Fréquence pour chaque empan",
    'collocTypeByTimeId' : "Nombre de cooccurrents différents (types) pour chaque empan",
    'collocType' : "Nombre de cooccurrents différents (types)",
    'collocTTR' : "Rapport type / tokens pour les cooccurrents différents",
    'specByTimeId' : "Spécificité dans chaque empan", 
    'cumFreqByTimeId' : "Fréquence cumulée pour chaque empan",
    'timeId': "Empan",
    'timeSpecByTimeId' : "Spécificité temporelle dans chaque empan",
    'timeSpecificity' : "Spécificité temporelle",
    'timeSpanSize' : "Taille de l'empan en tokens",
    'choseRealization' : "Choisissez une réalisation",
    'choseColloc' : "Choisissez un cooccurrent",
    'choseCorpus' : "Choisissez un sous-corpus",
    'occsByRealization' : "Occurrences par réalisation",
    'occsBySubCorpus' : "Occurrences par sous-corpus",
    'occurrences' : "Occurrences",
    'evolutionGlobal' : "Evolution globale pour toutes les réalisations",
    'evolutionForMoreFrequentReal' : "Evolution pour les réalisations les plus fréquentes",
    'evolutionForMoreFrequentColloc' : "Evolution pour les cooccurrents les plus fréquents",
    'play': "Ecouter l'audio",
    'info': "Info",
    'subCorpus' : "Sous-corpus",
    'filter' : "Filtre",
    'filterUsingRegex': "Filtrage à base de chaine ou de regex",
    'retryToLoadAlr' : "Il est possible que l'extraction ne soit pas encore terminée. Réessayez de 'Recharger' d'ici quelques minutes.",
    'reload' : "Recharger les résultats",
    'cumFrequency': "Fréquence cumulée",
    'relFrequency' : "Fréquence par million",
    'coeffExplanation' : "Le coefficient indique le rapport des occurrences entre la fin et le début de la période en cas d'augmentation, et le rapport inverse en cas de diminution.",
    'increasingCollocs' :"Coocurrents en augmentation",
    'decreasingCollocs' :"Coocurrents en régression",
    'increasingReals' :"Réalisations en augmentation",
    'decreasingReals' :"Réalisations en régression",
    'incDecCollocs' :"Coocurrents en augmentation puis en régression",
    'decIncCollocs' :"Coocurrents en régression puis en augmentation",
    'incDecReals' :"Réalisations en augmentation puis en régression",
    'decIncReals' :"Réalisations en régression puis en augmentation",

    'firstAttestation' : "Première attestation",
    'lastAttestation' : "Dernière attestation", 
    'totNbTokColon' : "Nombre total de tokens :",

    'tagsetColon' : "Jeu d'étiquettes :",
    'genreColon' : "Genre :",

    'warnMixedTagset' : "Attention, les corpus utilisent des jeux d'étiquettes différents. Certaines requêtes ne fonctionneront que sur une partie des corpus. Il est conseillé d'utiliser .* pour tous les tags.     Il est possible d'effectuer ce réglage dans [Paramères avancés/Concordances et occurrences/Traits pertinents] en supprimant le trait 'c'.",
    'noCorpusHasBeenSelected' :"Aucun corpus n'a été sélectionné. Cliquez sur un ou plusieurs corpus ci-dessous pour faire votre sélection.",
    
    'mergeSubCorpora' : "Fusionner les sous-corpus",
    'unselectAll' : "Tout déselectionner",
    'dist4cat' : "Proportion des répétitions pour chaque tranche de distance",
    'innerAssoc' : "Mesure d'association interne",
    'assoc' : "Mesure d'association",
    'referenceTQLColon' : "Documentation du langage de requête TQL :",
    'minNbCooc' : "Fréquence de cooccurrence minimale dans les résultats",
    'pattern': "Pattern",
    'terminologicWeight': "Poids terminologique",
    'extractionDefinition' : "Définition des extractions",
    'extractPatterns' : "Extraction des patterns (multi-termes)",
    'extractLexicometry' : "Extraction des données lexicométriques avancées",
    'conllMetadataDefinition' : "Définition des métadonnées conll",
    'idSentPattern' : "Identifiant de phrase (regex)",
    'timeIntPattern' : "Intervalle temporel (regex)",
    'speakerPattern' : "Locuteur (regex)",
    'repetitionDefinition' : "Définition des paramètres de répétition",
    'maxSpanSize' : "Taille de l'empan de répétition",
    'useLemma4Repet' : "Prise en compte des lemmes (vs formes)",
    'lemmaFormatDefinition' : "Définition du format des lemmes",
    'supprUnderScore' : "Suppression de underscore pour les lemmes soudés",
    'import' : "Importation de corpus",
    'patternStats' : "Fréquence des patterns",
    'notEnoughRight' : "Ces contenus sont soumis à copyright. Il n'est possible que d'en afficher des extraits courts.",
    'pagePrec': "Page précédente",
    'pageNext': "Page suivante",
    'docPrec' : "Document précédent",
    'docNext' : "Document suivant",
    'reading' : "Lecture",
    'takeOnlyNodeInRealization' : "Ne prendre en compte que le pivot #1 dans la réalisation (le reste de la requête étant donc uniquement contextuel).",
    'validateChanges' : "Valider les changements",
    'selectTheCorpusToDisplay':"Sélection des sous-corpus à afficher",
    'filteringAttr':"Critère de filtrage",
    'filteringVal':"Valeur de filtrage",
    'metadataFilters' : "Ajouter des filtres sur les métadonnées",
    'addTheCriterion' : "Ajouter le critère à la requête",
    'pos':"Position dans le doc %",
    'association':"Mesure d'association",
    'colloc':"Collocations",
    'noResultsFor':"Pas de résultats pour ",
    'results':"Résultats",
    'history':"Historique",
    'queryHistory':"Historique des requêtes",
    'clearHistory': "Effacer tout l'historique",
    'historyIsEmpty': "Aucune requête enregistrée",
    'runAlrAgainWithNewParam' : "Relancer l'extraction (avec éventuellement de nouveaux paramètres)",
    'wsByRealization':"Wordsketches en fonction des réalisations du pivot",
    'displayTree':"Afficher l'arbre syntaxique",
    'pasteThisQuery':"Coller cette requête",
    'orCopyPasteHereTheValuesInTheTextArea':"Ou copier/coller la liste des valeurs dans le champ ci-dessous",
    'addTheValues':"Ajouter ces valeurs",
    'TTRSpanSize':"Taille de l'empan pour le calcul de STTR (Standardized Type/Token Ratio)",
    'TTRSpanSizeColon':"Taille de l'empan pour le calcul de STTR (Standardized Type/Token Ratio) :",
    'StanzaModelName':"Nom du(des) modèle(s) Stanza (facultatif, séparés par une virgule)",
    'for': "pour",
    'innerCollocsDetails' : "Mesure d'association interne : détail du calcul",
    'leaf':"Feuille",
    'tree':"Arbre",
    'mlmStats' : "Modèle de langage",
    'runMLM' : "Lancer le modèle de langage (MLM)",
    'mlm' : "Modèle de langage masqué",
    'averageProba': "Probabilité moyenne",
    'guessedProba' : "Proportion de prédiction exacte",
    'similarForms' : "Formes similaires prédites",
    'parallelCorpus' : "Corpus parallèle",
    'alreadyAligned' : "Corpus déjà aligné (format TXT, TSV ou TMX)",
    'anErrorHasOccuredDuringImportation' : "Une erreur est survenue lors de l'importation. Revoir le format des fichiers.",
    'sessionTimeOut': "La session a expiré. Merci de vous reconnecter.",
    'realizations': "Réalisations",
    'publicCollections': "Collections publiques",
    'privateCollections': "Collections privées",
    'addCustomCorpus':"Ajouter un corpus privé",
    'keywords':"Mots clés décrivant le corpus",
    'keywordsHelp':"Séparez les mots clés par une virgule (ils seront utiles pour effectuer des filtrages)",
    'currentResultsCanBeSavedInYourPersonalDirectoriesOnTheServer': "Les résultats actuels peuvent être enregistrés sur le serveur dans votre répertoire personnel.",
    'saveResults':"Enregistrer les résultats courants",
    'resultsHaveBeenSaved':"Les résultats ont été enregistrés dans votre espace personnel",
    'filterHelp':"filtrage par mot-clé",
    'savedResults':"Résultats enregistrés",
    'suppressResultsExplanation': 'Ces résultats vont être supprimés. Attention cette opération ne peut être annulée par la suite.',
    'savedResultsHeader' : "Résultats précédemment enregistrés",
    'cooccurrence' : "Cooccurrence",
    'widenSearch' : "Pas de résultat : élargir la recherche",
    'foundSentsColon' : "Phrases trouvées :",
    'loadingResults' : "Chargement des résultats.",
    'initialization' : "Initialisation de la recherche...",
    'translation' : "Traductions",
    'clickOnUnfoldedButtonToSeeParallelCorpus':"Décochez 'KWIC/Déplié' pour voir les phrases alignées",
    'eraseContentLemmas':"Effacer les lemmes pleins",
    'chooseDataType':"Choisissez le type de données",
    'maxNumberOfLemmasToConsider':"Nombre max. de lemmes à prendre en compte",
    'filteringRegex':'Regex de filtrage',
    'computeMultivar':'Lancer le calcul à partir des données sélectionnées',
    'value':'Valeur',
    'anErrorHasOccurred':"Une erreur est survenue...",
    'alreadyParsed':"Corpus déjà parsé au format XML-CONLL",
    'first5000MoreFrequent':"Sélection des 5000 lemmes les plus fréquents",
    'first5000MoreSpecific':"Sélection des 5000 lemmes les plus spécifiques au sous-corpus",
    'calcContextTree':"Extraire les arbres contextuels en vue du partitionnement des contextes",
    'maxCooc':"Nombre maximal de cooccurrents retenus par réalisation",
    'computingStatistics':"Calcul des statistiques (peut-être long avec le calcul de la mesure d'association interne)...",
    'averageSurf':"Surface moyenne",
    'fullRealOrBytoken':"Choisir le type de réalisation",
    'fullRealization':"Réalisation complète",
    'filterOutUpperCase':"Ne pas afficher les lemmes en majuscule",
    'savedQueriesHeader':"Requêtes enregistrées",
    'savedQueries':"Requêtes enregistrées",
    'confirmAddNewQuery':"Confirmez-vous l'ajout d'une nouvelle requête ?",
    'newSavedQueryExplanation':"Un nouvelle requête va être ajoutée à votre liste de requêtes",
    'newSavedQuery':"Nouvelle requête enregistrée",
    'addNewSavedQuery':"Ajout d'une nouvelle requête",
    'saveModifications':"Sauvegarder les modifications",
    'suppressQueriesExplanation':"Voulez-vous supprimer cette requête enregistrée de votre compte ?",
    'numQuery':"Req.N°",
    'selectedCorpus':"Corpus sélectionné"


  },
};
